export const EPSILON = 0.00000001;

export function calculateSplitPercentages(totalPercentage: number, count: number, decimalPoints: number = 1): number[] {
  const multiplier = 10 ** decimalPoints;
  totalPercentage = totalPercentage * multiplier;
  const splitPercentage = totalPercentage / count;
  const floor = Math.floor(splitPercentage);
  const remainder = splitPercentage - floor;

  let remainderSum = 0;
  let percentageSum = 0;

  const splitPercentages: number[] = [];
  for (let i = 0; i < count - 1; i++) {
    let percentage = floor;
    remainderSum += remainder;
    if (remainderSum > 1) {
      percentage += 1;
      remainderSum -= 1;
    }
    percentageSum += percentage;
    splitPercentages.push(percentage);
  }
  splitPercentages.push(totalPercentage - percentageSum);

  for (let j = 0; j < splitPercentages.length; j++) {
    splitPercentages[j] /= multiplier;
  }
  return splitPercentages;
}

export function round(value: number, precision: number): number {
  let multiplier = Math.pow(10, precision);
  return (Math.round(value * multiplier) / multiplier);
}